/**
 * @author       matt@zumper.com (Matthieu Devlin)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Actions for traktor-middleware
 */

import type { User } from '@zcode/bizos'
import { type TrackEventPayload as _TrackEventPayload, event as _event } from '@zcode/integrations'
import type { Filters, Location, State } from '@zcode/state-type'

export interface TrackEventPayload extends _TrackEventPayload {
  filters?: Filters
  location?: Location
  user?: Pick<State['localUser'] | User, 'email' | 'userId'>
}

export const event = _event<TrackEventPayload>
